import { apiRequest } from '../api/http'
import type { SalesAnalyticsParams, SalesAnalyticsReport } from './types'

const ANALYTICS_BASE = '/api/analytics'

export async function getSalesAnalytics(accessToken: string, params: SalesAnalyticsParams): Promise<SalesAnalyticsReport> {
  const search = new URLSearchParams()
  search.set('range', params.range)
  if (params.range === 'CUSTOM') {
    if (params.from) search.set('from', params.from)
    if (params.to) search.set('to', params.to)
  }
  search.set('timeZone', params.timeZone)
  search.set('granularity', params.granularity)
  search.set('compare', String(params.compare))
  if (params.channelConnectionId !== undefined) search.set('channelConnectionId', String(params.channelConnectionId))

  return apiRequest<SalesAnalyticsReport>(ANALYTICS_BASE, `/sales?${search.toString()}`, { accessToken })
}
